import useSite from '../hooks/useSite';
import { useSetAtom } from 'jotai';
import { showIframeViewAtom } from '../states/planner';
import tomodal from '../assets/tomodal.svg';

export const IframeButton = () => {
  const setShowIframeView = useSetAtom(showIframeViewAtom);
  const [site] = useSite();

  if (!site?.galleryButton || site.galleryButton.type !== 'iframe') return null;

  return (
    <button
      onClick={() => setShowIframeView(true)}
      className="bottom-14 left-2 flex w-auto items-center gap-2 whitespace-nowrap rounded-md bg-black bg-opacity-50 px-3 py-1 text-sm text-white opacity-90 sm:origin-center sm:transform sm:transition sm:duration-100 sm:hover:scale-105"
    >
      Galleri
      <img src={tomodal} alt="open modal" className="" />
    </button>
  );
};
